export const UserConstants = {

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGOUT: 'USERS_LOGOUT',
    DRIVERS_SUCCESS: 'DRIVERS_SUCCESS',
    DRIVERS_REQUEST: 'DRIVERS_REQUEST',
    DRIVERS_ERROR: 'DRIVERS_ERROR',
    DRIVER_SUCCESS: 'DRIVER_SUCCESS',
    DRIVER_REQUEST: 'DRIVER_REQUEST',
    DRIVER_ERROR: 'DRIVER_ERROR',

    CERTIFICATE_SUCCESS: 'CERTIFICATE_SUCCESS',
    CERTIFICATE_REQUEST: 'CERTIFICATE_REQUEST',
    CERTIFICATE_ERROR: 'CERTIFICATE_ERROR',
    UNCONFIRMED_SUCCESS: 'UNCONFIRMED_SUCCESS',
    UNCONFIRMED_REQUEST: 'UNCONFIRMED_REQUEST',
    UNCONFIRMED_ERROR: 'UNCONFIRMED_ERROR',
    CONFIRM_CERTIFICATE: 'CONFIRM_CERTIFICATE,',

    CERTIFICATESBD_REQUEST: 'CERTIFICATESBD_REQUEST',
    CERTIFICATESBD_SUCCESS: 'CERTIFICATESBD_SUCCESS',
    CERTIFICATESBD_ERROR: 'CERTIFICATESBD_ERROR',
    
    DRIVERSBC_REQUEST: 'DRIVERSBC_REQUEST',
    DRIVERSBC_SUCCESS: 'DRIVERSBC_SUCCESS',
    DRIVERSBC_ERROR: 'DRIVERSBC_ERROR',
    UCDETAILS_REQUEST: 'UCDETAILS_REQUEST',
    UCDETAILS_SUCCESS:'UCDETAILS_SUCCESS',
    UCDETAILS_ERROR:'UCDETAILS_ERROR',
    DELETE_CERTIFICATE: 'DELETE_CERTIFICATE'



/*    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',

    DELETE_REQUEST: 'USERS_DELETE_REQUEST',
    DELETE_SUCCESS: 'USERS_DELETE_SUCCESS',
    DELETE_FAILURE: 'USERS_DELETE_FAILURE'*/
};



// WEBPACK FOOTER //
// ./src/constants/UserConstants.jsx